import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

import { TextAlignPropType, VerticalAlignPropType } from '../../services/proptypes';
import ContentMarkup from './ContentMarkup';
import ContentImage from './ContentImage';

export default function Content({ children, ...gridProps }) {
  if (!children || children.length === 0) {
    return null;
  }
  return (
    <Grid className="content-section" {...gridProps}>
      {children}
    </Grid>
  );
};

Content.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  columns: PropTypes.string,
  textAlign: TextAlignPropType,
  verticalAlign: VerticalAlignPropType,
};

Content.defaultProps = {
  children: null,
  columns: 'equal',
  textAlign: 'center',
  verticalAlign: 'middle',
};

Content.Markup = ContentMarkup;
Content.Image = ContentImage;
